import { render, staticRenderFns } from "./FastSearch.vue?vue&type=template&id=84923812"
import script from "./FastSearch.vue?vue&type=script&lang=js"
export * from "./FastSearch.vue?vue&type=script&lang=js"
import style0 from "./FastSearch.vue?vue&type=style&index=0&id=84923812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports